import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';


const filter = {
	Month: null as number | null,
	Year: null as number | null,
	MonthYear: null as string | null,
	GrnStartDate: null as Date | null,
	GrnEndDate: null as Date | null,
	OrganizationIds: [1] as number[],
	WareHouseId: null as number | null,
};

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		OrganizationId: [],
		WareHouseId: [],
	},
	filter,
	tableSetting: {
		isEditable: true,
		columnSettings: {
			VALUE: { isEditable: true, required: true },
		},
	},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
